if (!customElements.get("comparison-template")) {
  customElements.define(
    "comparison-template",
    class ComparisonTemplate extends HTMLElement {
      constructor() {
        super();
        this.prodFloatBanner = this.querySelector(".prod-float-banner");
        // 滚动结束元素标记
        this.prodComparisonBlocks = Array.from(
          this.querySelectorAll(".prod-comparison-block")
        );
        this.scrollEndTip =
          this.prodComparisonBlocks[this.prodComparisonBlocks.length - 1];

        this.listenerCollapse();
        this.syncOverflowX2Banner()
        this.init();
      }

      init() {
        const _this = this;
        const itemTitle = Array.from(
          this.querySelectorAll(".prod-swiper-item-title")
        )[0];

        window.addEventListener("scroll", () => {
          const scrollTop =
            window.scrollY || document.documentElement.scrollTop;
          if (
            (this.querySelector(".prod-params-collapse-btn") &&
              this.querySelector(
                ".prod-params-collapse-btn"
              ).classList.contains("open")) ||
            !this.querySelector(".prod-params-collapse-btn") || this.getWinClientWidth() <=768
          ) {
            if (
              scrollTop > _this.calc(itemTitle) &&
              scrollTop <
                _this.calc(itemTitle) +
                  this.querySelector(
                    ".prod-params-collapse"
                  ).getBoundingClientRect().height
            ) {
              _this.prodFloatBanner.classList.remove("hidden-banner");
            }
            //   else if(scrollTop){
            //     _this.prodFloatBanner.classList.add("hidden-banner");
            //   }
            else {
              _this.prodFloatBanner.classList.add("hidden-banner");
            }
          }
        });
      }
      calc(dom, distance) {
        if(dom&&dom.offsetParent){
          distance = distance || 0;
          if (["BODY", null].includes(dom.offsetParent.nodeName)) {
            distance += dom.offsetTop;
            return distance;
          } else {
            distance += dom.offsetTop;
            return this.calc(dom.offsetParent, distance);
          }
        }
        
      }
      getWinClientWidth() {
        return (
          document.documentElement.clientWidth || document.body.clientWidth
        );
      }
      syncOverflowX2Banner() {
        const wrapper = this.querySelector('.prod-comparison-swiper-wrapper')
        wrapper.addEventListener("scroll", (e) => {
          $(this.prodFloatBanner).css({
            transform: `translate3d(-${wrapper.scrollLeft}px,0px,0px)`,
          });
        });
      }

      // 折叠
      listenerCollapse() {
        const collapseBtn = this.querySelector(".prod-params-collapse-btn");
        const prodParamsCollapse = this.querySelector(".prod-params-collapse");
        if (!collapseBtn) return;
        collapseBtn.onclick = () => {
          console.log('1111')
          $(collapseBtn).toggleClass("open");
          $(prodParamsCollapse).slideToggle(500);
        };
      }
    }
  );
}
